<ion-modal #modal [isOpen]="isModalOpen" [class]="isModalOpen ? 'show' : 'hide'"  class="initial-modal" (didDismiss)="closeModal()">
  <ng-template>
    <div class="initial-modal__content"  [class]="isModalOpen ? 'show' : 'hide'" [class]="{'initial-modal__content--check' : arrived}">
      <img class="initial-modal__content__image" src="/assets/icon/pres-1.svg">
      <div  class="initial-modal__content__text" *ngIf="arrived">
        {{'SUIVI_DEMAND.PROVIDER.PROVIDER_ARRIVED' | translate}}
      </div>
      <div  class="initial-modal__content__text" *ngIf="!arrived">
        {{'SUIVI_DEMAND.PROVIDER.YOUR_REQUEST_IS_SENT' | translate}}
      </div>
      <ng-container *ngIf="arrived; else notArrived">
        <div class="btn-group">
          <app-button
            [typeNumber]="0"
            [innerText]="'BUTTONS.CONFIRM' | translate"
            [loading]="confirmLoading"
            [disabled]="buttonsDisabled"
            [styles]="initialModalButtonStyles('#75c2f6')"
            (onClick)="goToLoaderPage.emit()"
          ></app-button>
          <app-button
            [innerText]="'BUTTONS.NOTYET' | translate"
            [loading]="cancelLoading"
            [disabled]="buttonsDisabled"
            [styles]="initialModalButtonStyles('#88a8c7', 'cancle-btn')"
            (onClick)="providerNotArrived()"
          ></app-button>
        </div>
      </ng-container>
      <ng-template #notArrived>
        <app-button
          [typeNumber]="0"
          [innerText]="'BUTTONS.OK_2' | translate"
          [styles]="initialModalButtonStyles('#75c2f6')"
          (onClick)="closeModal()"
        ></app-button>
      </ng-template>
    </div>
  </ng-template>
</ion-modal>